import React from "react";
import { Link } from "react-router-dom";
import tutifyLogo from "../../assets/images/tutify-logo-dark.png";

const HeaderLogo = () => {
  return (
    <Link className="navbar-brand" to="/">
      <img style={{ height: "32px" }} src={tutifyLogo} alt="Tutify Logo" />
    </Link>
  );
};

export default HeaderLogo;
